//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.article`
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    width: 58%;
    min-width: 430px;
    &:not(.transparent) {
        background-color: var(--light-blue-2);
        padding: 18px;
    }
    & img {
        width: 25px;
    }
    & p {
        font-size: 14px;
        line-height: 20px;
        margin: 0;
    }
    @media (max-width: 750px) {
        width: 100%;
        min-width: unset;
    }
`;